/**
 * File: constants.ts
 * Description: Application-wide configuration constants. Derives the API base URL from the current Vite build mode so development and production targets are resolved automatically.
 */

export const NODE_ENV = import.meta.env.MODE;

export const API_URL = NODE_ENV === "development" ? "http://localhost:8090" : "https://feu.vigo.khoraurbanthinkers.es";

export const EMAIL_VIGO_FEU = "feuvigo@khoraurbanthinkers.es"
